import React, { useState, useEffect } from 'react'
import { useTranslation } from '~/hooks/useTranslation'
import { getApi } from '~/util/api'
import { Card, Typography } from '~/components/_atoms'
import { Stack } from '~/components/_layouts'
import Spinner from '~/components/shared/Spinner'
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '~/lib/ui/carousel'
import YnsIcon from '~/components/icons/YnsIcon'
export function NetworkingEventsCard({ className, color = 'secondary' }) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const [calendarEvents, setCalendarEvents] = useState({ events: [] })

  useEffect(() => {
    setIsLoading(true)
    getApi()
      .get('coach_services/upcoming_webinars')
      .then((response) => {
        if (response.status == 200) {
          setCalendarEvents(response.data)
          return
        } else {
          throw new Error('json request failed')
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
      .catch((error) => {
        console.log('json request failed', error)
      })
  }, [setCalendarEvents])

  return (
    <Card
      className={className}
      color={color}
      title={t('networking_events_card.title')}
      titleColor="secondary"
    >
      <Stack spacing={3}>
        <Typography>{t('networking_events_card.description')}</Typography>
        {isLoading ? (
          <div className="flex items-center justify-center ">
            <Spinner show size={9} />
          </div>
        ) : (
          <Card
            color="secondary"
            title={t('networking_events_card.upcoming_webinars_title')}
            titleColor="secondary"
            icon={<YnsIcon name="calendar" size={24} />}
          >
            <div className="grid grid-cols-[1fr] gap-x-8">
              <div className="relative w-full min-w-0 px-12">
                <Carousel className="w-full">
                  <CarouselContent className="-ml-4">
                    {calendarEvents.events.map((event) => (
                      <CarouselItem key={`event_${event.id}`} className="pl-4">
                        <div>
                          <Typography variant="title4" color="secondary">
                            {event.webinar_type}
                          </Typography>
                          <Typography variant="subtitle">
                            {event.formatted_start_at}
                          </Typography>
                          <Typography variant="small">
                            {event.description}
                          </Typography>
                        </div>
                      </CarouselItem>
                    ))}
                  </CarouselContent>
                  <CarouselPrevious className="-left-12 border-intoo-green-medium-800 bg-intoo-green-medium-800 text-white hover:bg-intoo-green-medium-700 hover:text-white" />
                  <CarouselNext className="-right-12 border-intoo-green-medium-800 bg-intoo-green-medium-800 text-white hover:bg-intoo-green-medium-700 hover:text-white" />
                </Carousel>
              </div>
            </div>
          </Card>
        )}
      </Stack>
    </Card>
  )
}
